<template>
  <StepLayout
    :back="back"
    :next="next"
    :isEditRoute="true"
    helpscoutArticle="66619ef0f0fdf93e4cf0ad6d"
    buttonDataEc="envelopes_signing_sequence_page"
  >
    <template v-slot:title>
      {{ $t('ui.envelopes.create.steps.signingSequence.title') }}
    </template>

    <SigningSequenceSelector
      v-if="!isPendingEnvelope"
      id="envelopes"
      ec="envelopes"
      :showTitle="false"
      :current-selection="sequence"
      @selectionUpdated="setSequence"
    >
      <template v-slot:parallelLabel="{ forId }">
        <SequenceLabel
          :label="$t('signingSequence.ui.labels.parallel')"
          :for="forId"
        >
          {{ $t('ui.envelopes.create.steps.signingSequence.descriptions.parallel') }}
        </SequenceLabel>
      </template>
      <template v-slot:sequentialLabel="{ forId }">
        <SequenceLabel
          :label="$t('signingSequence.ui.labels.sequential')"
          :for="forId"
        >
          {{ $t('ui.envelopes.create.steps.signingSequence.descriptions.sequential') }}
        </SequenceLabel>
      </template>
    </SigningSequenceSelector>
  </StepLayout>
</template>

<script setup>
// @ts-check
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router/composables';

import {
  useCreateUpdateEnvelope,
  useEnvelope,
  useEnvelopesStepsNavigation,
} from '@/composables/envelopes';
import {
  useUpdateWithValidation,
  useValidation,
} from '@/composables/envelopes/validation';
import { watchFalse } from '@/composables/utils/watchFalse';
import { EnvelopeUpdate } from '@/store/modules/envelopes/models/Envelope';

import StepLayout from '@/components/layouts/StepLayout';
import SequenceLabel from '@/components/ui/signingSequence/labels/SequenceLabel.vue';
import SigningSequenceSelector from '@/components/ui/signingSequence/SigningSequenceSelector.vue';

const route = useRoute();

const { envelope, isPendingEnvelope } = useEnvelope(route.params.fingerprint);

const { updateEnvelope } = useCreateUpdateEnvelope(route.params.fingerprint);

// local state
const sequence = ref();
watchFalse(isPendingEnvelope, () => {
  sequence.value = envelope.value?.parallel_signing ? 'parallel' : 'sequential';
});
/** @param {string} newSequence */
function setSequence(newSequence) {
  sequence.value = newSequence;
}

const SequenceUpdate = EnvelopeUpdate.pick({
  parallel_signing: true,
}).required();

const sequenceUpdate = computed(() => ({ parallel_signing: sequence.value === 'parallel' }));

const { isValid, data, validate } = useValidation(
  sequenceUpdate,
  SequenceUpdate,
);

const update = useUpdateWithValidation(updateEnvelope, data, validate);

const { back, next } = useEnvelopesStepsNavigation(update, isValid);
</script>
